import React from 'react';
import FacturesPage from '../components/FacturesPage';
import * as api from '../api';

export default function FacturesDistribution() {
  return (
    <FacturesPage
      title="Factures Distribution"
      fetchFn={api.getFacturesDistribution}
      getPdfFn={api.getFactureDistributionPdf}
      syncFn={(id) => api.syncFactureDistributionPl(id)}
      onRefreshFn={() => api.syncAllFacturesDistributionPl()}
      getDocumentOrigine={f => ({
        label: f.bl_numero || f.devis_numero || '—',
        href:  f.bl_id     ? `/bons-livraison-ventes?bl=${f.bl_id}`
             : f.vente_id  ? `/ventes?open_devis=${f.vente_id}`
             : null,
      })}
    />
  );
}
